const MATERIAL_IMPORT_LOG = '/admin/material-import-log'

export {
    MATERIAL_IMPORT_LOG
}